import { type FC } from "react";
import { Box, Typography } from "@mui/material";
import type { ObjectItem, SelectObjectTypeConfig } from "../types";

export interface ItemComponentProps {
  item: ObjectItem;
  config?: SelectObjectTypeConfig;
}

/**
 * Renders item: title + description (path or config.itemComponent).
 * When config.itemComponent is set, renders only it (custom component owns title and content).
 * Otherwise renders title + item.path.
 */
export const ItemComponent: FC<ItemComponentProps> = ({ item, config }) => {
  if (config?.itemComponent) {
    const CustomItem = config.itemComponent;
    return <CustomItem item={item} />;
  }

  const title = item.title ?? item.id;
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography
        variant="body1"
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {title}
      </Typography>
      {item.path && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {item.path}
        </Typography>
      )}
    </Box>
  );
};
